
<div *ngIf="structure">
  <ng-container [ngSwitch]="getLayout()">
    <ng-container *ngSwitchCase="'flexbox'">
      <collapsible-header-left-sidebar-layout
        [header]="getHeader()"
        [nav]="getNav()"
        [main]="getMain()"
        [footer]="getFooter()"
      ></collapsible-header-left-sidebar-layout>
    </ng-container>
    <ng-container *ngSwitchCase="'nosidebar'">
      <no-sidebar-layout
        [header]="getHeader()"
        [main]="getMain()"
        [footer]="getFooter()"
      ></no-sidebar-layout>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <collapsible-header-left-sidebar-layout
        [header]="getHeader()"
        [nav]="getNav()"
        [main]="getMain()"
        [footer]="getFooter()"
      ></collapsible-header-left-sidebar-layout>
    </ng-container>
  </ng-container>
</div>
